module.exports = __webpack_public_path__ + "static/media/2-tantsevalnyse.bc406e85.jpg";